import { Box, Stack, Typography, useMediaQuery, Link } from "@mui/material"
import { useState, useContext } from "react"
import { useTheme } from "@mui/material/styles"
import { ChatIconCTA, FC, SpecialTag, Button, SvgIcon } from ".."
import StickyTripBannerWrapper from "./StickyTripBannerWrapper"
import { SiteMetadataContext } from "../../local/wrappers/SiteMetadataProvider"
import { type TripData, TripModal, InquiryModal } from ".."

const StickyTripBannerVar = ({ trip }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [openInquiryModal, setOpenInquiryModal] = useState(false)
  const [openTripModal, setOpenTripModal] = useState(false)
  const siteMetadata = useContext(SiteMetadataContext)

  return (
    <>
      <StickyTripBannerWrapper>
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{
          width: "100%", flexWrap: {
            xs: "wrap",
            xl: "nowrap"
          }
        }} gap={3}>
          <Typography
            variant="heading.md"
            sx={(theme) => ({
              color: theme.palette["neutral.100"].main,
              fontSize: {
                xs: "16px",
                xl: "22px"
              },
              pr: {
                xs: "80px",
                md: 0
              }
            })}
          >
            {isMobile ? "Speak to a Destination Specialist" : "Don’t see the perfect option? Request a custom quote."}
          </Typography>
          <Stack direction={{
            xs: "row-reverse",
            md: "row"
          }} alignItems="center" gap={{
            xs: 0,
            md: 4,
            xl: 7.5
          }}>
            <Box display="flex" alignItems="center">
              <Button
                variant="quaternary"
                aria-label="Inquire Now"
                onClick={() => {
                  if (trip) {
                    setOpenTripModal(true)
                  } else {
                    setOpenInquiryModal(true)
                  }
                }}
                sx={{
                  minHeight: "50px!important",
                  alignSelf: "center",
                  padding: {
                    xs: "10px 15px!important",
                    xl: "12.5px 23px!important",
                  },
                  fontSize: {
                    xs: "14px",
                    xl: "18px",
                  },
                  display: { xs: "inline-flex" },
                  color: theme.palette["neutral.100"].main
                }}
              >
                Request a Custom Quote
              </Button>
            </Box>
            {/* Phone button */}
            <Box
              component="span"
              sx={(theme) => ({
                ...theme.typography["link.md"],
                backgroundColor: theme.palette["primary.800"].main,
                borderRadius: 1,
                lineHeight: 1,
                transition: theme.transitions.create(["background-color", "border-color", "color"]),
                mr: {
                  xs: "16px",
                  md: 0
                },
                "&:hover": {
                  backgroundColor: theme.palette["primary.900"].main,
                },
              })}
            >
              <Link
                href={siteMetadata.phoneUrl}
                variant="link.sm"
                display="flex"
                alignItems="center"
                minHeight="50px"
                gap="8px"
                color={(theme) => theme.palette["neutral.100"].main}
                underline="none"
                sx={{
                  textDecoration: "none",
                  padding: {
                    xs: theme.spacing(2.5, 4.6),
                    xl: theme.spacing(3, 5),
                  },
                }}
              >
                {siteMetadata.phone}
              </Link>
            </Box>
            {/* chat icon button */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: {
                  xs: 2,
                  xl: 2.5,
                },
                color: theme.palette["neutral.100"].main,
                fontWeight: 600,
                lineHeight: "140%",

                "#chat-button": {
                  position: {
                    xs: "absolute",
                    md: "static",
                  },
                  bottom: {
                    xs: "100px",
                    sm: "95px",
                  },
                  width: 62,
                  height: 62,
                  boxShadow: "none",
                  display: "flex !important",
                  opacity: "1 !important",
                  transform: "none !important",
                  transition: "none !important",
                },

                "#chat-button > div": {
                  alignItems: "center",
                },

                "#chat-button svg": {
                  width: 22,
                  height: 22,
                },

                "#chat-button p": {
                  lineHeight: 1.5,
                },
              }}
            >
              <Typography variant="body.md" component="span" sx={{
                fontWeight: 600,
                display: {
                  xs: "none",
                  sm: "none",
                  md: "flex",
                },
                fontSize: {
                  md: "14px",
                  lg: "16px",
                  xl: "18px",
                },
              }} >
                Live Chat Now
              </Typography>
              <ChatIconCTA />
            </Box>
          </Stack>
        </Box>
      </StickyTripBannerWrapper>

      <InquiryModal open={openInquiryModal} onClose={() => setOpenInquiryModal(false)} />
      {trip && (
        <TripModal
          open={openTripModal}
          onClose={() => setOpenTripModal(false)}
          trip={trip as TripData}
        />
      )}
    </>
  )
}

export default StickyTripBannerVar
